/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeedBackTypeEnum } from './feedBackTypeEnum';
import { GeneralFeedbackEventTypeEnum } from './generalFeedbackEventTypeEnum';


export interface FeedbackDto { 
    id: number;
    creatorId?: string;
    serviceProvidername?: string;
    serviceName?: string;
    shortCode?: string;
    dateCreated: Date;
    answerType?: string;
    serverMessage?: Array<string>;
    description?: Array<string>;
    expiryDate: Date;
    phoneNumber?: string;
    contentName?: string;
    serviceTypeName?: string;
    generalFeedbackEventType: GeneralFeedbackEventTypeEnum;
    feedbackType: FeedBackTypeEnum;
}
